var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors[0])?_c('ul',{staticClass:"alert alert-danger"},_vm._l((_vm.errors),function(error,i){return _c('li',{key:i},[_vm._v("\n    "+_vm._s(error)+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }